/** Single-token filler/noise the async transcriber often emits on silence or echo. */
const FILLER_TOKENS = new Set(['um', 'uh', 'hmm', 'hm', 'ah', 'oh', 'er', 'mm', 'huh', 'mhm']);

const isFillerOnly = (text) => {
  const tokens = text
    .toLowerCase()
    .replace(/[.!?,…]/g, ' ')
    .split(/\s+/)
    .filter(Boolean);
  if (tokens.length === 0) return true;
  return tokens.every((token) => FILLER_TOKENS.has(token));
};

/**
 * Returns true when a finalized user transcript looks like intentional speech
 * (not silence, echo garbage, or filler). Barge-in turns use the same bar —
 * the user deliberately interrupted, but we still ignore empty/noise transcripts.
 */
export function isMeaningfulUserSpeech(transcript, { bargeIn = false } = {}) {
  const text = (transcript || '').trim();
  if (!text) return false;

  const minLen = bargeIn ? 2 : 2;
  if (text.length < minLen) return false;

  if (!/\p{L}/u.test(text)) return false;

  if (isFillerOnly(text)) return false;

  if (/^[\s.,!?\-–—…]+$/.test(text)) return false;

  return true;
}
